import _ from 'underscore';
import React, { useContext, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import {
  IconButton,
  Text,
} from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useResponsiveSize } from '@adscore/with-responsive-size';

import { PersonIcon } from './person-icon';

const getStyles = () => ({
  button: {
    height: '48px',
    minWidth: '48px',
    padding: '0px 12px',
    '&:hover': {
      '& .user-name': {
        color: '#0f6cbd',
      },
      '& .person-icon >path': {
        fill: '#0f6cbd',
      },
    },
    '& .ms-Button-menuIcon': {
      display: 'none',
    },
  },
  buttonText: {
    fontSize: '12px',
    fontWeight: 600,
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginLeft: '14px',
    maxWidth: '220px',
  },
});

export const MeControl = ({
  userName,
  signOutUrl,
  customizedSignOut,
}) => {
  const classes = useDefaultStyles(getStyles);
  const i18n = useContext(I18nContext);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);
  const showName = displayMode === 'xxl' || displayMode === 'xl';

  const handleSignOut = useCallback(() => {
    if (_.isFunction(customizedSignOut)) {
      customizedSignOut();
      return;
    }

    window.location.href = signOutUrl;
  }, [customizedSignOut, signOutUrl]);

  const menuProps = useMemo(() => ({
    items: [
      {
        key: 'sign-out-item-key',
        className: 'sign-out-item',
        text: i18n.getString(_TL_('Sign out')),
        onClick: handleSignOut,
      },
    ],
    doNotLayer: true,
  }), [handleSignOut, i18n]);

  return (
    <IconButton
      className={classNames(classes.button, 'me-control-button')}
      menuProps={menuProps}
      id="me-control-button"
      aria-label={i18n.getString(_TL_('Sign out'))}
    >
      <PersonIcon className="person-icon" />
      {showName && userName &&
        <Text
          className={classNames(classes.buttonText, 'user-name')}
          title={userName}
        >
          {userName}
        </Text>
      }
    </IconButton>
  );
};

MeControl.propTypes = {
  userName: PropTypes.string.isRequired,
  signOutUrl: PropTypes.string,
  customizedSignOut: PropTypes.func,
};

MeControl.defaultProps = {
  customizedSignOut: undefined,
  signOutUrl: '#',
};
